import axios from "axios";

export default axios.create({
  baseURL: process.env.REACT_APP_API + "/block",
  headers: {
    "Content-Type": "application/json"
  }
});
